/* eslint-disable max-len */
import {
    MetaDispatcher as SourceMetaDispatcher
} from 'SourceStore/Meta/Meta.dispatcher';
import { updateMeta } from 'Store/Meta/Meta.action';
import { appendWithStoreCode } from 'Util/Url';

/** @namespace Pwa/Store/Meta/Dispatcher/MetaDispatcher */
export class MetaDispatcher extends SourceMetaDispatcher {
    // TODO implement logic

    updateWithContact(mData, dispatch) {
        const meta = this._getContactMeta(mData);
        dispatch(updateMeta(meta));
    }

    _getProductMeta(product) {
        const {
            name,
            meta_title,
            meta_keyword,
            canonical_url,
            meta_description,
            short_description,
            oggraphData = {}
        } = product;

        const {
            hreflang,
            contact_us_snippet,
            oggraph
        } = oggraphData;

        const { html } = short_description || {};
        const description = this.stripHtml(html) || meta_description;

        return {
            description,
            keywords: meta_keyword,
            title: meta_title || name,
            canonical_url: `${window.location.origin}${window.storeConfig.baseName}${appendWithStoreCode(canonical_url)}`,
            hreflang,
            contact_us_snippet,
            oggraph
        };
    }

    stripHtml(html) {
        // Create a new div element
        const temporalDivElement = document.createElement('div');
        // Set the HTML content with the providen
        temporalDivElement.innerHTML = html;
        // Retrieve the text property of the element (cross-browser support)
        return temporalDivElement.textContent || temporalDivElement.innerText || '';
    }

    _getContactMeta(mdata) {
        const {
            title,
            hreflang,
            contact_us_snippet,
            oggraph
        } = mdata;

        return {
            title,
            hreflang,
            contact_us_snippet,
            oggraph,
            canonical_url: window.location.href
        };
    }

    _getCategoryMeta(category) {
        const {
            description, name, canonical_url,
            meta_title, meta_keywords, meta_description,
            meta_robots = 'follow, index',
            oggraphData = {}
        } = category;
        const {
            hreflang,
            contact_us_snippet,
            oggraph
        } = oggraphData;

        return {
            description: meta_description || description,
            title: meta_title || name,
            keywords: meta_keywords,
            canonical_url: `${window.location.origin}${window.storeConfig.baseName}${appendWithStoreCode(canonical_url)}`,
            robots: meta_robots,
            hreflang,
            contact_us_snippet,
            oggraph
        };
    }
}

export default new MetaDispatcher();
